export default __webpack_public_path__ + "static/media/character-kanetugu.dc57e10e.png";